import {BoxService} from "./box-service";
import {Images} from "./images";
import {Encoder} from "./encoder";
import {Navigation} from "./navigation";
import {UiService} from "./services/ui-service";

const images = new Images();
const encoder = new Encoder();
const boxService = new BoxService(images, encoder);
const navigation = new Navigation(encoder, boxService);
const uiService = new UiService();

export class ServiceLocator {
	public static get images() { return images; }
	public static get boxService() { return boxService; }
	public static get navigation() { return navigation; }
	public static get uiService() { return uiService; }
}
